import React, { memo, useMemo, useCallback } from "react";
import { useT } from "@al/next/al-ex";
import cls from "classnames";
import { Tabs } from "@al/akui-mobile";
import { useScrollTop } from "@al/rc-util/lib/hooks/use-scroll-top";

import { scrollToYSmooth } from "~/common/utils/scrollTo";

import styles from "./styles.scss";
import { domYState, TabKey } from "./utils";

const tabValues = [
  { name: "商品", key: TabKey.Product },
  { name: "评价", key: TabKey.Evaluate },
  { name: "详情", key: TabKey.Description },
  // { name: "推荐", key: TabKey.Recommend },
];

const FixedTab: React.FC = () => {
  const t = useT();
  // 0.56 距离顶部 + 0.47 Tab 高度 + 0.08 间距
  const currentY = useMemo(() => (process.browser ? window.rem2px(1.1) : 110), [process.browser]);
  const scrollTop = useScrollTop({ scrollFinshedThreshold: 100 });
  // 动态计算透明度
  const opacity = useMemo(() => {
    let temp = 0;
    if (process.browser) {
      const TopBarHeight = window.rem2px(0.56);
      if (scrollTop >= TopBarHeight * 3) {
        temp = 1;
      } else if (scrollTop <= TopBarHeight / 10) {
        temp = 0;
      } else {
        temp = Number((scrollTop / 2 / TopBarHeight).toFixed(2));
      }
    }
    return temp || 0;
  }, [scrollTop]);

  // 计算当前选中的 tab
  const activeKey = useMemo(() => {
    for (const [key, el] of Object.entries(domYState).reverse()) {
      if (el && scrollTop >= el.offsetTop - currentY - 1) {
        return key;
      }
    }
    return String(TabKey.Product);
  }, [scrollTop]);

  const onTabChange = useCallback(
    (key: string): void => {
      const targetY = domYState[key]?.offsetTop || 0;
      const y = domYState[key] && targetY - currentY > 0 ? Math.floor(targetY - currentY) : 0;
      // 当剩余高度不足一屏时，无法通过滚动计算当前高亮tab，就通过点击给予高亮
      scrollToYSmooth(y);
    },
    [currentY]
  );

  return (
    <div className={cls(styles.tabs_wrap, opacity === 0 && styles.hide)} style={{ opacity }}>
      <Tabs onChange={onTabChange} activeKey={activeKey as string}>
        {tabValues.map((item) => (
          <Tabs.Tab key={item.key} title={t(item.name)} />
        ))}
      </Tabs>
    </div>
  );
};

export default memo(FixedTab);
